import React from "react";
import { Row, Col, Form, Select, Input, Button, Drawer, DatePicker } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import closeX from "../../../../assets/images/close-x.svg";
import data from "../../../../constants/retailPos.json";

const { Option } = Select;

const UAECustomerCreationDrawer = ({
  displayUAECustomer,
  setDisplayUAECustomer,
  UAECustomerForm,
  setInputValues,
  registrationTypes,
  refs,
  getInputValue,
  onChangeInput,
  onFocusInput,
  renderThumbHorizontalScroll,
  renderThumb,
  customerLoading,
  addNewCustomer,
  setCustomerSearchInput,
}) => {
  return (
    <Drawer
      styles={{ body: { padding: "0 24px" } }}
      closable={false}
      placement="bottom"
      title={
        <div style={data.posScreenStyles.customerModal.customerDetailsCard}>
          <p
            style={{
              marginBottom: "0px",
              fontSize: "1.5em",
              // marginTop: "1%",
              fontWeight: "500",
              color: "#0F0718",
              textAlign: "center",
            }}
          >
            UAE Customer
          </p>
          <img
            onClick={() => {
              setDisplayUAECustomer(false);
              UAECustomerForm.resetFields();
              setInputValues({
                name: "",
                lastName: "",
                email: "",
                mobile: "",
                pincode: "",
                street: "",
                city: "",
                pincode1: "",
                taxID: "",
                cardNumber: "",
              });
            }}
            style={{ cursor: "pointer", width: "1.5vw", position: "absolute", right: "0.5vw", top: "2vh" }}
            src={closeX}
            alt=""
          />
        </div>
      }
      headerStyle={{borderBottom: "none"}} 
      bodyStyle={{ backgroundColor: "#f3f4f9" }}
      open={displayUAECustomer}
      className="addCustomer"
      onClose={() => {
        setDisplayUAECustomer(false);
        UAECustomerForm.resetFields();
      }}
      height="87vh"
    >
      <div>
        <Form key={"addCustomer"} form={UAECustomerForm} name="addCustomer" style={{ padding: "0 5%" }}>
          <Scrollbars renderThumbHorizontal={renderThumbHorizontalScroll} renderThumbVertical={renderThumb} style={{ height: "58vh" }}>
            <div style={{ fontSize: "1vw" }}>
              <Row>
                <Col span={12} style={{ padding: "0 2vw 0 2vw", marginTop: "2.5vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Type</label>
                  <Form.Item name="type" disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Select size="large" className="genderSelect">
                      {registrationTypes?.map((type) => (
                        <Option key={type.value} value={type.value}>
                          {type.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12} style={{ padding: "0 2vw 0 4vw", marginTop: "2.5vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Card Number</label>
                  <Form.Item form={UAECustomerForm} name="cardNumber" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input
                      ref={refs.cardNumber}
                      value={getInputValue("cardNumber")}
                      onChange={onChangeInput}
                      onFocus={() => {
                        onFocusInput("cardNumber");
                      }}
                      id="sm-product-search"
                      className="customerDetailsInput"
                      placeholder="Card Number"
                      style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                    />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 2vw 0 2vw", marginTop: "2.5vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Validaity</label>
                  <Form.Item name="validaity" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <DatePicker style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 2vw 0 4vw", marginTop: "2.5vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>First Name</label>
                  <Form.Item name="name" rules={[{ required: true, message: "Please Input First Name" }]} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input
                      ref={refs.name}
                      value={getInputValue("name")}
                      onChange={onChangeInput}
                      onFocus={() => {
                        onFocusInput("name");
                      }}
                      id="sm-product-search"
                      className="customerDetailsInput"
                      placeholder="First Name"
                      style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                    />
                  </Form.Item>
                </Col>
                <Col span={12} style={{ padding: "0 2vw 0 2vw", marginTop: "2.5vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Last Name</label>
                  <Form.Item form={UAECustomerForm} name="lastName" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input
                      ref={refs.lastName}
                      value={getInputValue("lastName")}
                      onChange={onChangeInput}
                      onFocus={() => {
                        onFocusInput("lastName");
                      }}
                      id="sm-product-search"
                      className="customerDetailsInput"
                      placeholder="Last Name"
                      style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                    />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 2vw 0 4vw", marginTop: "4vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Phone Number (optional)</label>
                  <Form.Item
                    name="mobile"
                    rules={[
                      {
                        required: true,
                        pattern: new RegExp(/^[0-9]\d*$/),
                        message: "Please Input Valid Phone Number",
                      },
                    ]}
                    style={data.posScreenStyles.addEditCustomerModal.formItem}
                  >
                    <Input
                      ref={refs.mobile}
                      value={getInputValue("mobile")}
                      onChange={onChangeInput}
                      onFocus={() => {
                        onFocusInput("mobile");
                      }}
                      id="sm-product-search"
                      className="customerDetailsInput"
                      placeholder="Enter Phone Number"
                      style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                    />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 2vw 0 2vw", marginTop: "4vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Email (optional)</label>
                  <Form.Item form={UAECustomerForm} name="email" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input
                      ref={refs.email}
                      value={getInputValue("email")}
                      onChange={onChangeInput}
                      onFocus={() => {
                        onFocusInput("email");
                      }}
                      id="sm-product-search"
                      className="customerDetailsInput"
                      placeholder="Enter Email"
                      style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </Scrollbars>
          <Row>
            <Col span={18} />
            <Col span={6} style={{ display: "flex", justifyContent: "space-evenly" }}>
              <Button
                className="customerDetailsSubmitBtnBtn"
                style={{ color: "#0F0718", width: "9vw", fontWeight: "500", borderRadius: "3px", background: "#ffffff", fontSize: "1em", height: "5.5vh" }}
                onClick={() => setDisplayUAECustomer(false)}
              >
                Cancel
              </Button>
              <Button
                className="customerDetailsSubmitBtnBtn"
                style={{ color: "#ffffff", width: "9vw", fontWeight: "500", borderRadius: "3px", background: "#2F3856", fontSize: "1em", height: "5.5vh", paddingLeft: "1vw" }}
                loading={customerLoading}
                onClick={() => {
                  const value = UAECustomerForm.getFieldsValue();
                  addNewCustomer(value);
                  // setDisplayUAECustomer(false);
                  setCustomerSearchInput("");
                }}
              >
                Create
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </Drawer>
  );
};

export default UAECustomerCreationDrawer;
